import { clsxMerge, getS3AssetPath } from "shared/lib/helpers";
import { ContactDetailI } from "shared/lib/interfaces/account";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import { ProspectInfoBlock } from "@/modules/pipeline/account-details/shared/prospect-info-block";
import { ProspectEditMenu } from "@/modules/pipeline/account-details/shared/prospect-edit-menu";

interface LeadItemPropsI extends PropsWithClassNameI {
  contact: ContactDetailI;
  isBookMeetingFlow?: boolean;
}

export const AccountDetailsLeadItem = ({
  className,
  contact,
  isBookMeetingFlow,
}: LeadItemPropsI) => (
  <div className={clsxMerge("flex w-full gap-2", className)}>
    <img
      alt="Lead Avatar"
      src={getS3AssetPath(
        "platform/account-details/lead-avatar-placeholder.webp"
      )}
      className="h-8 w-8"
    />

    <ProspectInfoBlock
      contact={contact}
      isCallOnPhoneClickDisabled={isBookMeetingFlow}
      isCopyOnlyMode={isBookMeetingFlow}
    />

    <div className="flex items-start">
      <ProspectEditMenu contact={contact} />
    </div>
  </div>
);
